/**
 * What a conversation bubble shows when a message has no text to show.
 *
 * Usually that is "(no text)": a sticker, a photo without a caption. Since
 * 2026-10-27 one case says more. Under WhatsApp coexistence Meta delivers a
 * contact's FIRST message to a number onboarded from the WhatsApp Business app
 * without its words (error 131060); they reach the Business app only. The
 * server flags those (`unavailable_first_message`), and the bubble tells staff
 * where to read it, so nobody mistakes it for an empty message.
 */

export const EMPTY_BUBBLE_TEXT = "(no text)";

export const UNAVAILABLE_FIRST_MESSAGE_BUBBLE_TEXT =
  "First message: WhatsApp didn't pass on its text. Read it in the WhatsApp Business app.";

export function emptyBubbleText(msg: {
  readonly unavailable_first_message: boolean;
}): string {
  return msg.unavailable_first_message
    ? UNAVAILABLE_FIRST_MESSAGE_BUBBLE_TEXT
    : EMPTY_BUBBLE_TEXT;
}
